import React from "react";

function DivisionCard({ img, title, text, logo, styleLogo }) {
  return (
    <div
      className={`col-span-4 sm:col-span-2 lg:col-span-1 rounded-3xl h-fit-content bg-base-100 overflow-hidden text-center`}
    >
      <figure>
        <img src={img} alt={`divisions ${title}`} />
      </figure>
      <div className="card-body bg-white h-full pt-9 md:pt-4 px-7 rounded-b-[1.8rem]">
        <div className="flex justify-center items-start mt-1">
          <img src={logo} alt="logo" className={styleLogo} />
        </div>
        <p className="text-base text-center pb-4 leading-5 mt-3 tracking-normal md:tracking-[-0.015em]">
          {text}
        </p>
      </div>
    </div>
  );
}

export default DivisionCard;
